var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRechargeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0026 9.66732C8.92308 9.66732 9.66927 8.92113 9.66927 8.00065C9.66927 7.08018 8.92308 6.33398 8.0026 6.33398C7.08213 6.33398 6.33594 7.08018 6.33594 8.00065C6.33594 8.92113 7.08213 9.66732 8.0026 9.66732Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3359 6.33398V9.66732",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9974 12.0007C5.9974 12.5007 5.8574 12.974 5.61074 13.374C5.15074 14.1473 4.30406 14.6673 3.33073 14.6673C2.3574 14.6673 1.51072 14.1473 1.05072 13.374C0.804054 12.974 0.664062 12.5007 0.664062 12.0007C0.664062 10.5273 1.8574 9.33398 3.33073 9.33398C4.80406 9.33398 5.9974 10.5273 5.9974 12.0007Z",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32259 11.9863H2.33594",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32812 11.0137V13.007",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33594 10.1993V5.99935C1.33594 3.66602 2.66927 2.66602 4.66927 2.66602H11.3359C13.3359 2.66602 14.6693 3.66602 14.6693 5.99935V9.99935C14.6693 12.3327 13.3359 13.3327 11.3359 13.3327H5.66927",
    stroke: "#1C1C1C",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRechargeIcon);
export default __webpack_public_path__ + "static/media/rechargeIcon.a68753224300da81bae7c1f9e6ab285e.svg";
export { ForwardRef as ReactComponent };